import IconButton from "@mui/material/IconButton"
import useMediaState from "@/common/hooks/useMediaState";
import { ExplorerItem, MediaState } from "@/types/types";
import { useAudioPlayback } from "@/common/hooks/useAudioPlayback.ts";
import { OverridableStringUnion } from "@mui/types";
import { ButtonPropsSizeOverrides, SxProps, Theme } from "@mui/material";
import * as React from "react";
import useCurrentExplorerItem from "@/common/hooks/useCurrentExplorerItem.ts";
import PauseSharp from "@mui/icons-material/PauseSharp";
import PlayArrowSharp from "@mui/icons-material/PlayArrowSharp";

type Props = {
  explorerItem?: ExplorerItem,
  style?: React.CSSProperties;
  sx?: SxProps<Theme>;
  size?: OverridableStringUnion<"small" | "medium" | "large", ButtonPropsSizeOverrides>;
  startAt?: number;
  iconSize?: 'inherit' | 'small' | 'medium' | 'large';
}

export const PlayPauseButton = (props: Props) => {
  const {
    explorerItem,
    style,
    sx,
    size = "small",
    startAt,
    iconSize = "medium",
  } = props

  const [mediaState] = useMediaState()
  const isPlaying = mediaState === MediaState.PLAYING
  const currentExplorerItem = useCurrentExplorerItem()
  const { play, pause, seek } = useAudioPlayback()

  const handleOnClick = () => {
    if (isPlaying && explorerItem && explorerItem?.id === currentExplorerItem?.id) {
      pause()
    } else {
      play(explorerItem)

      if (startAt !== undefined && startAt >= 0) {
        setTimeout(() => {
          seek(startAt)
        }, 10)
      }
    }
  }

  return (
    <IconButton
      onClickCapture={() => handleOnClick()}
      style={style}
      sx={sx}
      size={size}
    >
      {isPlaying && explorerItem && explorerItem.id === currentExplorerItem?.id ? (
        <PauseSharp
          color={"primary"}
          fontSize={iconSize}
        />
      ) : (
        <PlayArrowSharp
          fontSize={iconSize}
        />
      )}
    </IconButton>
  )
}

export default PlayPauseButton;
